import { useMemo, useState } from 'react';
import { isBetterHost, isIframeTurkeyHost } from './hostsConfig';

function addLang(code, alias) {
  return {
    name: code,
    alias: alias?.toUpperCase() || code?.toUpperCase(),
  };
}

function getUrlLang(path, languages) {
  return path
    .split(/[/?]/)
    .filter(Boolean)
    .find((segment) => languages.includes(segment));
}

class LanguagesService {
  constructor(isBetterHost) {
    this.translations = {
      en: {
        Balance: 'Balance',
        Deposit: 'Deposit',
        Logout: 'Logout',
        'Log in': 'Log in',
        Register: 'Register',
        Username: 'Username',
        Password: 'Password',
        'Welcome back': 'Welcome back',
        Greeting:
          'We are happy to see you here again. Enter your username and password',
        GreetingAccount:
          'We are happy to see you again. Choose iFrame account you need',
        LoginError: "Can't login user with requested credentials.",
        Settings: "Settings",
        'Brand customization': "Brand customization",
        Languages: "Languages",
        'Color theme': "Color theme",
      },
      es: {
        Balance: 'Balance',
        Deposit: 'Depósito',
        Logout: 'Cerrar sesión',
        'Log in': 'Acceso',
        Username: 'Nombre de usuario',
        Password: 'Contraseña',
        'Welcome back': 'Bienvenido de nuevo',
        Greeting:
          'Estamos felices de verte aquí de nuevo. Ingrese su nombre de usuario y contraseña',
        GreetingAccount:
          'Nos alegra verte de nuevo. Elige la cuenta iFrame que necesitas',
        LoginError:
          'No se puede iniciar sesión como usuario con las credenciales solicitadas.',
        Settings: "Ajustes",
        'Brand customization': "Personalización de marca",
        Languages: "Idiomas",
        'Color theme': "Tema de color",
      },
      pt: {
        Balance: 'Equilíbrio',
        Deposit: 'Depósito',
        Logout: 'Sair',
        'Log in': 'Conecte-se',
        Username: 'Nome de usuário',
        Password: 'Senha',
        'Welcome back': 'Bem vindo de volta',
        Greeting:
          'Estamos felizes em ver você aqui novamente. Digite seu nome de usuário e senha',
        GreetingAccount:
          'Estamos felizes em vê-lo novamente. Escolha a conta iFrame que você precisa',
        LoginError:
          'Não é possível fazer login do usuário com as credenciais solicitadas.',
        Settings: "Configurações",
        'Brand customization': "Personalização da marca",
        Languages: "Idiomas",
        'Color theme': "Tema de cores",
      },
      fr: {
        Balance: 'Équilibre',
        Deposit: 'Dépôt',
        Logout: 'Se déconnecter',
        'Log in': 'Se connecter',
        Username: "Nom d'utilisateur",
        Password: 'Mot de passe',
        'Welcome back': 'Content de te revoir',
        Greeting:
          "Nous sommes heureux de vous revoir ici. Entrez votre nom d'utilisateur et votre mot de passe",
        GreetingAccount:
          'Nous sommes heureux de vous revoir. Choisissez le compte iFrame dont vous avez besoin',
        LoginError:
          "Impossible de connecter l'utilisateur avec les informations d'identification demandées.",
        Settings: "Paramètres",
        'Brand customization': "Personnalisation de la marque",
        Languages: "Langages",
        'Color theme': "Thème de couleur",
      },
      zh: {
        Balance: '平衡',
        Deposit: '订金',
        Logout: '登出',
        'Log in': '登录',
        Username: '用户名',
        Password: '密码',
        'Welcome back': '欢迎回来',
        Greeting: '我们很高兴再次在这里见到您。 输入你的用户名与密码',
        GreetingAccount: '我们很高兴再次见到您。选择您需要的iFrame账户',
        LoginError: '无法使用请求的凭据登录用户。',
      },
      hi: {
        Balance: 'शेष राशि',
        Deposit: 'जमा',
        Logout: 'लॉगआउट',
        'Log in': 'लॉग इन',
        Username: 'उपयोगकर्ता नाम',
        Password: 'पासवर्ड',
        'Welcome back': 'वापसी पर स्वागत है',
        Greeting: 'ग्रीटिंग',
        GreetingAccount: 'हमें आपको फिर से देखकर खुशी हो रही है। आपको जिस iFrame खाते की आवश्यकता है उसे चुनें',
        LoginError: 'लॉगिनत्रुटि',
      },
      tr: {
        Balance: 'Denge',
        Deposit: 'Depozito',
        Logout: 'Çıkış Yap',
        'Log in': 'Giriş yapmak',
        Username: 'Kullanıcı adı',
        Password: 'Şifre',
        'Welcome back': 'tekrar hoşgeldiniz',
        Greeting: 'Selamlama',
        GreetingAccount:
          'Sizi tekrar görmekten mutluyuz. İhtiyacınız olan iFrame hesabını seçin',
        LoginError: 'Sisteme giriş hatası',
      },
      de: {
        Balance: 'Gleichgewicht',
        Deposit: 'Kaution',
        Logout: 'Ausloggen',
        'Log in': 'Anmeldung',
        Username: 'Nutzername',
        Password: 'Passwort',
        'Welcome back': 'Willkommen zurück',
        Greeting:
          'Wir freuen uns, Sie wieder hier zu sehen. Geben Sie Ihren Benutzernamen und Ihr Passwort ein',
        GreetingAccount:
          'Wir freuen uns, Sie wiederzusehen. Wählen Sie das iFrame-Konto, das Sie benötigen',
        LoginError:
          'Benutzer kann sich mit den angeforderten Anmeldeinformationen nicht anmelden.',
        Settings: "Einstellungen",
        'Brand customization': "Markenanpassung",
        Languages: "Sprachen",
        'Color theme': "Farbthema",
      },
      ko: {
        Balance: '균형',
        Deposit: '보증금',
        Logout: '로그아웃',
        'Log in': '로그인',
        Username: '사용자 이름',
        Password: '비밀번호',
        'Welcome back': '환영합니다',
        Greeting: '다시 만나서 반갑습니다. 사용자 이름과 비밀번호를 입력하세요',
        GreetingAccount: '다시 만나서 반갑습니다. 필요한 iFrame 계정을 선택하세요',
        LoginError: '요청된 자격 증명으로는 사용자가 로그인할 수 없습니다.',
      },
      ru: {
        Balance: 'Баланс',
        Deposit: 'Депозит',
        Logout: 'Выйти',
        'Log in': 'Вход',
        Username: 'Имя пользователя',
        Password: 'Пароль',
        'Welcome back': 'Добро пожаловать',
        Greeting: 'Введите имя пользователя и пароль',
        GreetingAccount: 'Мы рады видеть вас снова. Выберите нужную учетную запись iFrame',
        LoginError: 'Такой пользователь не существует.',
      },
      ar: {
        Balance: 'توازن',
        Deposit: 'إيداع',
        Logout: 'تسجيل الخروج',
        'Log in': 'تسجيل الدخول',
        Username: 'اسم المستخدم',
        Password: 'كلمة المرور',
        'Welcome back': 'مرحبًا بعودتك',
        Greeting: 'تحية',
        GreetingAccount: 'نحن سعداء لرؤيتك مرة أخرى. اختر حساب iFrame الذي تحتاجه',
        LoginError: 'خطأ في تسجيل الدخول.',
      },
      ur: {
        Balance: 'توازن',
        Deposit: 'جمع',
        Logout: 'لاگ آؤٹ',
        'Log in': 'لاگ ان کریں۔',
        Username: 'صارف نام',
        Password: 'پاس ورڈ',
        'Welcome back': 'دوبارہ خوش آمدید',
        Greeting: 'سلام کرنا',
        LoginError: 'لاگ ان ایرر.',
      },
      he: {
        Balance: 'יתרה',
        Deposit: 'הפקדה',
        Logout: 'התנתקות',
        'Log in': 'התחברות',
        Username: 'שם משתמש',
        Password: 'סיסמה',
        'Welcome back': 'ברוכים השבים',
        Greeting: 'ברכה',
        GreetingAccount: 'אנחנו שמחים לראות אותך שוב. בחר את חשבון ה-iFrame שאתה צריך',
        LoginError: 'שגיאת התחברות',
      },
    };
    this.languages = isBetterHost
      ? [addLang('en'), addLang('es'), addLang('pt'), addLang('zh', '汉语')]
      : isIframeTurkeyHost
        ? [addLang('en')]
        : [
          addLang('en'),
          addLang('de'),
          addLang('fr'),
          addLang('es'),
          addLang('pt'),
          addLang('tr'),
          addLang('ar'),
          addLang('ur'),
          addLang('he'),
          addLang('hi', 'हिन्दी'),
          addLang('zh', '汉语'),
          addLang('ko', '한국어'),
        ];

    const langsNames = this.languages.map(({ name }) => name);
    const currentLang = getUrlLang(window.location.href, langsNames);
    const lang = currentLang || localStorage.getItem('lang');
    const hasLang = this.languages
      .map(({ name }) => name)
      .find((name) => name === lang);
    this.defaultLanguage = lang !== 'null' && !!lang && hasLang ? lang : 'en';
    this.lang = this.defaultLanguage;
    localStorage.setItem('lang', this.lang);
  }

  t(key) {
    return this.translations[this.lang][key] || key;
  }

  setLang(lang) {
    this.lang = lang;
    localStorage.setItem('lang', this.lang);
  }
}

const instance = new LanguagesService(isBetterHost);

export default instance;

export const useLanguageService = () => {
  const [lang, setLang] = useState(instance.lang);

  const t = instance.t.bind(instance);
  const langCodes = useMemo(
    () => instance.languages.map(({ name }) => name),
    [],
  );
  const rtlLangs = ['ar', 'ur', 'he'];
  const isRtl = rtlLangs.includes(lang);

  const updateLang = (newLang) => {
    setLang(newLang);
    instance.setLang(newLang);
  };

  return {
    setLang: updateLang,
    lang,
    t,
    languages: instance.languages,
    langCodes,
    isRtl,
  };
};
